export default (Types, namespace) => {
  const path = `${namespace}/`;
  return Object.keys(Types).reduce((res, type) => {
    /* eslint-disable-next-line */
    res[type] = Object.keys(Types[type]).reduce((labels, label) => {
    /* eslint-disable-next-line */
    labels[label] = `${path}${Types[type][label]}`;
      return labels;
    }, {});
    return res;
  }, {});
};
